export default "__VITE_ASSET__1iR0AMEy__"